import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { getFramesDisplayPrice } from "../../../../../utils/modules/EcommContent/FramesEcommContent/utils/get-frames-display-price.js";
import { useProductDetailQueryParams } from "../../../../../../../../hooks/hooks/use-product-detail-query-params.js";
import { getSelectedOffering } from "../../../../../../utils/modules/EcommContent/utils/get-selected-offering.js";
import { ChannelAvailability } from "../../../../../../../../types/types/product.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { isRxProductAction } from "../../../../../../../../types/types/typeguards.js";
const FramesEcommContext = React.createContext({});
const useFramesEcommContext = () => React.useContext(FramesEcommContext);
const FramesEcommProvider = ({ children }) => {
  const {
    activeVariant: { channelAvailability, sku },
    displayPrice: unmodifiedDisplayPrice,
    product
  } = useProductData();
  const { isPrescriptionGlassesEnabled, isRxPriceFromEnabled } = useFeatureToggles();
  const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
  const handleConfiguratorOpen = () => {
    setIsConfiguratorOpen(true);
  };
  const handleConfiguratorClose = () => {
    setIsConfiguratorOpen(false);
  };
  const { filteredOfferings, isReimbursable } = useProductDetailQueryParams();
  const offerings = product.offerings?.filter(
    (offering) => isReimbursable ? offering.isInsuranceReimbursable : !offering.isInsuranceReimbursable
  );
  const [selectedOffering, setSelectedOffering] = React.useState(
    getSelectedOffering(offerings, filteredOfferings)
  );
  const displayPrice = getFramesDisplayPrice(unmodifiedDisplayPrice, selectedOffering);
  const productAction = React.useMemo(() => {
    const fallbackAction = channelAvailability === ChannelAvailability.ONLINE && isPrescriptionGlassesEnabled ? "OPEN_CONFIGURATOR" : "OPEN_CONFIGURATOR_UNAVAILABLE";
    const variantAction = selectedOffering?.actions.find((action) => action.variantSku === sku);
    return variantAction ? variantAction.action : fallbackAction;
  }, [isPrescriptionGlassesEnabled, channelAvailability, selectedOffering, sku]);
  const shouldDisplayFromPrice = Boolean(isRxPriceFromEnabled && isRxProductAction(productAction));
  const value = React.useMemo(
    () => ({
      productAction,
      isConfiguratorOpen,
      handleConfiguratorOpen,
      handleConfiguratorClose,
      offerings,
      selectedOffering,
      setSelectedOffering,
      displayPrice,
      shouldDisplayFromPrice
    }),
    [
      displayPrice,
      isConfiguratorOpen,
      offerings,
      productAction,
      selectedOffering,
      shouldDisplayFromPrice
    ]
  );
  return /* @__PURE__ */ React.createElement(FramesEcommContext.Provider, { value }, children);
};
export {
  FramesEcommContext,
  FramesEcommProvider,
  useFramesEcommContext
};
//# sourceMappingURL=FramesEcommContext.js.map
